import { useState } from 'react'
import { JACKPOT_CONTRIBUTIONS_TAB } from '@constants/jackpotConstants'
import JackpotTopContributionsTable from './JackpotTopContributionsTable'
import JackpotMyContributionsTable from './JackpotMyContributionsTable'

// Pill sub-tab bar (Top/My Contributions) — Active shows both; History shows
// only "My Contributions" and hides the pill bar entirely (nothing to switch
// between), matching defenderV2's `showTabBar = tabs.length > 1`.
const JackpotContributionsTab = ({ jackpotId, viewType }) => {
  const tabs = JACKPOT_CONTRIBUTIONS_TAB[viewType] ?? JACKPOT_CONTRIBUTIONS_TAB.ACTIVE
  const [currentTab, setCurrentTab] = useState(tabs[0]?.KEY)
  const activeIndex = tabs.findIndex((tab) => tab.KEY === currentTab)
  const showTabBar = tabs.length > 1

  return (
    <div className="standard-normal-jackpot-contributions-outer-container">
      {showTabBar && (
        <div className="standard-normal-jackpot-contributions-header-container">
          <div
            className="standard-normal-jackpot-contributions-header-inner-container"
            style={{
              '--jackpot-contrib-tab-count': tabs.length,
              '--jackpot-contrib-tab-index': activeIndex,
            }}
          >
            {tabs.map((tab) => (
              <div
                key={tab.KEY}
                className={`standard-normal-jackpot-contributions-tab ${tab.KEY === currentTab ? 'standard-normal-jackpot-contributions-active-tab' : ''}`}
                onClick={() => setCurrentTab(tab.KEY)}
              >
                {tab.LABEL}
              </div>
            ))}
            <span className="standard-normal-jackpot-contributions-tab-indicator" aria-hidden="true" />
          </div>
        </div>
      )}

      <div
        className={`standard-normal-jackpot-contributions-body-container ${!showTabBar ? 'standard-normal-jackpot-contributions-body-full-height' : ''}`}
      >
        {currentTab === 'TOP' ? (
          <JackpotTopContributionsTable />
        ) : (
          <JackpotMyContributionsTable jackpotId={jackpotId} />
        )}
      </div>
    </div>
  )
}

export default JackpotContributionsTab
